// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_NavbarContainer__OrRDq {
  position: fixed;
  width: 100%;
  z-index: 10;
  left: 0;
  top: 0;
  box-sizing: border-box;
  padding: 0.6rem;
}

.styles_NavbarOnTop__-qA2r {
  padding: 0.8rem;
}

/* nav links - start */
.styles_navItemsWrapper__gJ3fR {
  position: relative;
  display: block;
  padding: 10px 0;
}

.styles_navItemsWrapper__gJ3fR:active {
  transform: translateY(0.1rem);
  transition: transform 0.01s ease;
}
/* nav links - end */

.styles_NavbarContainer__OrRDq > div {
  box-sizing: border-box !important;
}

@media (max-width: 1200px) {
  .styles_NavbarContainer__OrRDq > div {
    padding: 0.6rem 1.2rem !important; 
  }
  
  .styles_NavbarContainer__OrRDq > div > div:last-child {
    width: auto !important; 
  }
}

@media (max-width: 900px) {
  .styles_NavbarContainer__OrRDq > div > div:last-child > a {
    display: none !important; 
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/styles.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,WAAW;EACX,OAAO;EACP,MAAM;EACN,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;AACA,oBAAoB;;AAEpB;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".NavbarContainer {\n  position: fixed;\n  width: 100%;\n  z-index: 10;\n  left: 0;\n  top: 0;\n  box-sizing: border-box;\n  padding: 0.6rem;\n}\n\n.NavbarOnTop {\n  padding: 0.8rem;\n}\n\n/* nav links - start */\n.navItemsWrapper {\n  position: relative;\n  display: block;\n  padding: 10px 0;\n}\n\n.navItemsWrapper:active {\n  transform: translateY(0.1rem);\n  transition: transform 0.01s ease;\n}\n/* nav links - end */\n\n.NavbarContainer > div {\n  box-sizing: border-box !important;\n}\n\n@media (max-width: 1200px) {\n  .NavbarContainer > div {\n    padding: 0.6rem 1.2rem !important; \n  }\n  \n  .NavbarContainer > div > div:last-child {\n    width: auto !important; \n  }\n}\n\n@media (max-width: 900px) {\n  .NavbarContainer > div > div:last-child > a {\n    display: none !important; \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NavbarContainer": `styles_NavbarContainer__OrRDq`,
	"NavbarOnTop": `styles_NavbarOnTop__-qA2r`,
	"navItemsWrapper": `styles_navItemsWrapper__gJ3fR`
};
export default ___CSS_LOADER_EXPORT___;
